import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/store/authStore';

/**
 * Redirects "/" to /dashboard when authenticated, otherwise to /login.
 */
export const RoleBasedRedirect = () => {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/dashboard" replace />;
};
